import React from "react"

const AccessoriesUsageSummary = ({ items = [], memoNo = null }) => {
  const quantities = items.map(i => Number(i?.quantity) || 0)

  const totalAdded = quantities
    .filter(qty => qty > 0)
    .reduce((sum, qty) => sum + qty, 0)

  const totalReturned = quantities
    .filter(qty => qty < 0)
    .reduce((sum, qty) => sum + Math.abs(qty), 0)

  return (
    <div className="d-flex flex-column gap-1">
      {/* Memo Number */}
      <div className="fw-semibold text-dark">
        {memoNo || "—"}
      </div>

      {/* Status Badges */}
      <div className="d-flex gap-2 flex-wrap small">
        {totalAdded > 0 && (
          <span className="badge bg-success-subtle text-success border border-success">
            <i className="fas fa-plus me-1"></i>
            Added {totalAdded}
          </span>
        )}

        {totalReturned > 0 && (
          <span className="badge bg-danger-subtle text-danger border border-danger">
            <i className="fas fa-undo me-1"></i>
            Returned {totalReturned}
          </span>
        )}

        {totalAdded === 0 && totalReturned === 0 && (
          <span className="badge bg-secondary-subtle text-secondary border">
            No change
          </span>
        )}
      </div>
    </div>
  )
}

export default AccessoriesUsageSummary
